var render = function render(){
  var _vm$value, _vm$value$resume, _vm$value$resume$pers;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-16"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    staticClass: "v-avatar--small",
    attrs: {
      "color": "grey"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.profileSrc
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.profileSrc,
      expression: "!profileSrc"
    }],
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1)], 1)], 1)], 1), _c('v-col', [_c('v-layout', {
    staticClass: "flex-row flex-lg-column flex-xl-row align-center align-lg-start align-xl-center",
    staticStyle: {
      "gap": "4px"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium grey-13--text"
  }, [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$resume = _vm$value.resume) === null || _vm$value$resume === void 0 ? void 0 : (_vm$value$resume$pers = _vm$value$resume.personalInformation) === null || _vm$value$resume$pers === void 0 ? void 0 : _vm$value$resume$pers.name) + " ")]), _c('p', {
    staticClass: "page-text--sm grey-9--text"
  }, [_vm._v("(" + _vm._s(_vm.gender) + ", " + _vm._s(_vm.age) + ")")]), _c('application-view', _vm._b({
    ref: "application-view",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "my-n2",
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": "grey-9"
          }
        }, 'v-btn', Object.assign({}, attrs), false), on), [_c('v-icon', [_vm._v(" mdi-checkbox-multiple-blank-outline ")])], 1)];
      }
    }])
  }, 'application-view', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false))], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._l(_vm.cardTextList, function (text, i) {
    return [_c('span', {
      key: `card-text-item-${i}`,
      staticClass: "page-text--sm grey-6--text"
    }, [_vm._v(_vm._s(text))]), i < _vm.cardTextList.length - 1 ? _c('span', {
      key: `card-text-item-${i}-divider`,
      staticClass: "page-text--sm grey-6--text px-10"
    }, [_vm._v(" / ")]) : _vm._e()];
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }